@if (_active) {
  <kendo-window (close)="_closeForm()" (stateChange)="_onStateChanges($event)" title="SCHEDULE REPORTS"
    (keydown.enter)="$event.preventDefault()" class="scheduleReportForm ">
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row">
        <div class="col-12">
          <div class="borderedSections" [class.active-step-shedule-report]="currentStep === 1">
            <div class="row">
              <div class="col-12">
                <div class="rtClass">
                  When should the "Schedule Report" start?
                </div>
              </div>
              <div class="col-12 margin-top-10">
                <div class="row">
                  <div class="col-12 col-sm-4 col-md-3">
                    <label for="startdate" class="control-label reportslabel">
                      Choose Schedule Starting
                      Date/Time
                    </label>
                  </div>
                  <div class="col-12 col-sm-8 col-md-9">
                    <kendo-datepicker #kendo_customized_date_picker formControlName="schedulestartdate"
                      calendarType="infinite" [(value)]="_selectedDateTime"
                      [format]="_dateFormat" (close)="_closeCalendar()"
                      (open)="_scheduleStartDateEvent()"
                      class="visibleDateField scheduleReportMinWidth">
                    </kendo-datepicker>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-4 col-md-3">
                  </div>
                  <div class="col-12 col-sm-8 col-md-9">
                    <kendo-timepicker #kendo_customized_time_picker class="hiddenDateField"
                      [(value)]="_selectedDateTime" [format]="_TimeFormat" (open)="_withTime()"
                      (close)="_removeBodyClass()">
                    </kendo-timepicker>
                    <span class="notime" (click)="_removeTime()">
                      <span class="timeSpan">time</span><span class="skipTimeSpan">
                      skip<img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="borderedSections" [class.active-step-shedule-report]="currentStep === 2">
          <div class="row">
            <div class="col-12">
              <div class="rtClass">
                What is the "Recurrence Pattern" for the Schedule Report?
              </div>
            </div>
            <div class="col-12 margin-top-10">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-4 col-md-3">
                      <label class="control-label reportslabel">
                        Choose the Recurrence
                        Pattern
                      </label>
                    </div>
                    <div class="col-12 col-sm-8 col-md-9">
                      <kendo-combobox #kendo_Combo_Rec_Pattern formControlName="runtimeunit"
                        [data]="_runTimeData" class="scheduleReportMinWidth"
                        (open)="_openedCombo()" (close)="_closedCombo()"
                        (valueChange)="_recurrencePatternChange($event)">
                      </kendo-combobox>
                      <span class="comboSkipButton" (click)="_skipCombo()">
                        skip<img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                      </span>
                    </div>
                  </div>
                </div>
                @switch (_runTimeUnit) {
                  @case ('hourly') {
                    <div class="col-12">
                      <div class="recurContainer">
                        <div class="row">
                          <div class="col-12 col-sm-4 col-md-3">
                            <label class="control-label reportslabel">Recur Every</label>
                          </div>
                          <div class="col-12 col-sm-8 col-md-9">
                            <kendo-numerictextbox #Kendo_NumericBox_RecurrHourly
                              (keyup.enter)="_movetoRangeStep()"
                              (keydown.Tab)="_movetoRangeStep()" [value]=3 [min]=3
                              [format]="'n0'" formControlName="hourlynumberofhours"
                              class="scheduleReportMinWidth">
                            </kendo-numerictextbox>
                            <label class="control-label reportslabel sndLabelInline">Hour(s)</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @case ('daily') {
                    <div class="col-12">
                      <div class="recurContainer">
                        <div class="row">
                          <div class="col-12 col-sm-4 col-md-3">
                            <label class="control-label reportslabel">
                              Daily Recurrence
                              Patern
                            </label>
                          </div>
                          <div class="col-12 col-sm-8 col-md-9">
                            <kendo-combobox #kendo_Combo_Daily_Rec_Pattern
                              formControlName="dailyRecPattern" [data]="_dailyRecPatternData"
                              class="scheduleReportMinWidth"
                              (valueChange)="_dailyRecurrencePatternChange($event)">
                            </kendo-combobox>
                          </div>
                        </div>
                        @if (_form.value.dailyRecPattern == 'Every Day') {
                          <div class="row margin-top-10">
                            <div class="col-12 col-sm-4 col-md-3">
                              <label class="control-label reportslabel">Number of days</label>
                            </div>
                            <div class="col-12 col-sm-8 col-md-9">
                              <kendo-numerictextbox #Kendo_NumericBox_RecurrDaily
                                (keyup.enter)="_movetoRangeStep()"
                                (keydown.Tab)="_movetoRangeStep()" [value]=1 [min]=1
                                [format]="'n0'" formControlName="dayeveryhowmanydays"
                                class="scheduleReportMinWidth">
                              </kendo-numerictextbox>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @case ('weekly') {
                    <div class="col-12">
                      <div class="recurContainer">
                        <div style="display:none;" class="row">
                          <div class="col-12 col-sm-4 col-md-3">
                            <label class="control-label reportslabel">
                              Weekly Number Recurrence
                              Pattern
                            </label>
                          </div>
                          <div class="col-12 col-sm-8 col-md-9">
                            <kendo-numerictextbox #Kendo_NumericBox_RecurrWeekly
                              (keyup.enter)="_movetodaysMultiSelect()"
                              (keydown.Tab)="_movetodaysMultiSelect()" [value]=1 [min]=1
                              [format]="'n0'" formControlName="weeklyrecurs"
                              class="scheduleReportMinWidth">
                            </kendo-numerictextbox>
                          </div>
                        </div>
                        <div class="row margin-top-10">
                          <div class="col-12 col-sm-4 col-md-3">
                            <label class="control-label reportslabel">
                              Select
                              the Days of Recurrence
                            </label>
                          </div>
                          <div class="col-12 col-sm-8 col-md-9">
                            <div #kendo_multiselect_wrapper
                              class="customMultiSelectList customMultiSelectListReports">
                              <!-- (document:click)="_multiSelectClose($event)" -->
                              <kendo-multiselect #kendo_multiselect [summaryTagAfter]="0"
                                [ngModelOptions]="{standalone: true}"
                                [data]="_weeklyRecDays"
                                (valueChange)="_weeklyRecDaysevent($event)"
                                [(ngModel)]="_selectedweeklyRecDays" [autoClose]="false"
                                (keyup.enter)="_daysRecMultiselectclose()"
                                (keydown.Tab)="_daysRecMultiselectclose()"
                                (focusout)="_daysRecMultiselectclose()"
                                (close)="_daysRecMultiselectclose()"
                                class="customMultiSelect scheduleReportMinWidth"
                                placeholder="Select a Day"
                                textField="title" valueField="id">
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                  <input type="checkbox" class="k-checkbox"
                                    [checked]="_isItemSelected(dataItem.id)">
                                    <label class="k-checkbox-label">{{dataItem.title}}</label>
                                  </ng-template>
                                </kendo-multiselect>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    @case ('monthly') {
                      <div class="col-12">
                        <div class="recurContainer">
                          <div class="row">
                            <div class="col-12 col-sm-4 col-md-3">
                              <label class="control-label reportslabel">
                                Monthly Recurrence Pattern
                                Type
                              </label>
                            </div>
                            <div class="col-12 col-sm-8 col-md-9">
                              <kendo-combobox #kendo_Combo_Monthly_Rec_Pattern
                                formControlName="monthlyRecPattern"
                                [data]="_monthlyRecPatternData" class="scheduleReportMinWidth"
                                (valueChange)="_monthlyRecurrencePatternChange($event)">
                              </kendo-combobox>
                            </div>
                          </div>
                          @if (_form.value.monthlyRecPattern == 'Specific Date') {
                            <div class="row margin_top_10"
                              >
                              <div class="col-12 col-sm-4 col-md-3">
                                <label class="control-label reportslabel">
                                  Choose Recurrence Day
                                  Number
                                </label>
                              </div>
                              <div class="col-12 col-sm-8 col-md-9">
                                <kendo-numerictextbox #Monthly_Specific_day_numeric
                                  (keyup.enter)="_movetoofEveryRadio()" [value]=1 [min]=1
                                  [format]="'n0'" class="smallWidth"
                                  formControlName="dayeveryhowmanydays"
                                  class="scheduleReportMinWidth">
                                </kendo-numerictextbox>
                              </div>
                              <div class="col-12 col-sm-4 col-md-3 margin_top_10">
                                <label class="control-label reportslabel">
                                  Choose Number of
                                  Months
                                </label>
                              </div>
                              <div class="col-12 col-sm-8 col-md-9 margin_top_10">
                                <kendo-numerictextbox #Monthly_Specific_ofEvery_numeric
                                  (keyup.enter)="_monthlyNumberofMonth()"
                                  (keydown.Tab)="_monthlyNumberofMonth()"
                                  [value]=1 [min]=1
                                  [format]="'n0'" class="smallWidth"
                                  formControlName="monthlydayeverymonth"
                                  class="scheduleReportMinWidth">
                                </kendo-numerictextbox>
                              </div>
                            </div>
                          }
                          @if (_form.value.monthlyRecPattern == 'Specific Day') {
                            <div class="row margin_top_10"
                              >
                              <div class="col-12 col-sm-4 col-md-3">
                                <label class="control-label reportslabel">The</label>
                              </div>
                              <div class="col-12 col-sm-8 col-md-9">
                                <kendo-combobox #kendo_combo_specific_month
                                  (valueChange)="_openNextSpecificDay()"
                                  [data]="_listOfStartingAt" [suggest]="true"
                                  class="hideClearButton scheduleReportMinWidth"
                                  formControlName="monthlyspecificrank">
                                </kendo-combobox>
                              </div>
                              <div class="col-12 col-sm-4 col-md-3 margin_top_10">
                                <label class="control-label reportslabel">
                                  Choose The Date Recurrence
                                  Pattern
                                </label>
                              </div>
                              <div class="col-12 col-sm-8 col-md-9 margin_top_10">
                                <kendo-combobox #the_specific_NextDay
                                  (valueChange)="_focusOfEveryMonth()" [data]="_listOfDays"
                                  [suggest]="false" class="hideClearButton scheduleReportMinWidth"
                                  formControlName="monthlyspecificday">
                                </kendo-combobox>
                              </div>
                              <div class="col-12 col-sm-4 col-md-3 margin_top_10">
                                <label class="control-label reportslabel">
                                  Of
                                  every
                                </label>
                              </div>
                              <div class="col-12 col-sm-8 col-md-9 margin_top_10">
                                <kendo-numerictextbox #of_every_month_specific_numeric
                                  (keyup.enter)="_movetoROF()"
                                  (keydown.Tab)="_movetoROF()" [value]=1 [min]=1
                                  [format]="'n0'" class="smallWidth"
                                  formControlName="monthlyspecificeverymonth"
                                  class="scheduleReportMinWidth">
                                </kendo-numerictextbox>
                                <label class="control-label reportslabel sndLabelInline">Month(s)</label>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @case ('yearly') {
                      <div class="col-12">
                        <div class="recurContainer">
                          <div style="display:none;" class="row">
                            <div class="col-12 col-sm-4 col-md-3">
                              <label class="control-label reportslabel">
                                Yearly Number Recurrence
                                Pattern
                              </label>
                            </div>
                            <div class="col-12 col-sm-8 col-md-9">
                              <kendo-numerictextbox #recurr_every_year_numericbox
                                (keydown.Tab)="_moveToYearlyTypeRecurrencePattern()"
                                (keyup.enter)="_moveToYearlyTypeRecurrencePattern()"
                                [value]=1 [min]=1
                                [format]="'n0'" formControlName="yearlyrecurs"
                                class="scheduleReportMinWidth">
                              </kendo-numerictextbox>
                            </div>
                          </div>
                          <div class="row margin_top_10">
                            <div class="col-12 col-sm-4 col-md-3">
                              <label class="control-label reportslabel">
                                Yearly Type Recurrence
                                Pattern
                              </label>
                            </div>
                            <div class="col-12 col-sm-8 col-md-9">
                              <kendo-combobox #kendo_Combo_Yearly_Rec_Pattern
                                formControlName="yearlyRecPattern"
                                [data]="_yearlyRecPatternData" class="scheduleReportMinWidth"
                                (valueChange)="_yearlyRecurrencePatternChange($event)">
                              </kendo-combobox>
                            </div>
                          </div>
                          @if (_form.value.yearlyRecPattern == 'Specific Date') {
                            <div class="row margin_top_10"
                              >
                              <div class="col-12 col-sm-4 col-md-3">
                                <label class="control-label reportslabel">Choose The Date</label>
                              </div>
                              <div class="col-12 col-sm-8 col-md-9">
                                <kendo-datepicker #onYearDate_datepicker
                                  (valueChange)="_movetosheduleDate()" [format]="_dateFormat"
                                  formControlName="yearlydateon" class="scheduleReportMinWidth">
                                </kendo-datepicker>
                              </div>
                            </div>
                          }
                          @if (_form.value.yearlyRecPattern == 'Specific Day') {
                            <div class="row margin_top_10"
                              >
                              <div class="col-12 col-sm-4 col-md-3">
                                <label class="control-label reportslabel">Choose Week Number</label>
                              </div>
                              <div class="col-12 col-sm-8 col-md-9">
                                <kendo-combobox #week_Number_Combo [data]="_listOfStartingAt" [suggest]="true"
                                  class="scheduleReportMinWidth hideClearButton" formControlName="yearlyspecificrank"
                                  (valueChange)="_yearlyChooseWeekNumberEvent()">
                                </kendo-combobox>
                              </div>
                              <div class="col-12 col-sm-4 col-md-3 margin_top_10">
                                <label class="control-label reportslabel">Choose Weekday</label>
                              </div>
                              <div class="col-12 col-sm-8 col-md-9 margin_top_10">
                                <kendo-combobox #yearly_Weekday_Choose_Combo [data]="_listOfDays" [suggest]="true"
                                  class="hideClearButton scheduleReportMinWidth"
                                  formControlName="yearlyspecificday"
                                  (valueChange)="_yearlyChooseWeekdayNumberEvent()">
                                </kendo-combobox>
                              </div>
                              <div class="col-12 col-sm-4 col-md-3 margin_top_10">
                                <label class="control-label reportslabel">Choose Month</label>
                              </div>
                              <div class="col-12 col-sm-8 col-md-9 margin_top_10">
                                <kendo-combobox #yearly_Month_Choose_Combo [data]="_listOfMonths" [suggest]="true"
                                  class="hideClearButton scheduleReportMinWidth"
                                  formControlName="yearlyspecificmonth"
                                  (valueChange)="_yearlyChooseMonthEvent()">
                                </kendo-combobox>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="borderedSections" [class.active-step-shedule-report]="currentStep === 3">
            <div class="row">
              <div class="col-12">
                <div class="rtClass">
                  Do you want the "Schedule Report" to end?
                </div>
              </div>
              <div class="col-12 margin-top-10">
                <div class="row">
                  <div class="col-12 col-sm-4 col-md-3">
                    <label class="control-label reportslabel">Enable End Date</label>
                  </div>
                  <div class="col-12 col-sm-8 col-md-9">
                    <kendo-combobox #kendo_Combo_Enable_End_Date formControlName="enableEndDate"
                      [data]="_enableEndDateData" class="scheduleReportMinWidth"
                      (valueChange)="_enableEndDateChange($event)">
                    </kendo-combobox>
                  </div>
                </div>
                @if (_form.value.enableEndDate == 'With End Date') {
                  <div class="row margin-top-10">
                    <div class="col-12 col-sm-4 col-md-3">
                      <label class="control-label reportslabel">Choose End Date</label>
                    </div>
                    <div class="col-12 col-sm-8 col-md-9">
                      <kendo-datepicker #kendo_Choose_End_Date [format]="_dateFormat"
                        formControlName="scheduleenddatevalue" class="scheduleReportMinWidth"
                        (valueChange)="_endByDatePickerEvent()" (open)="_endByComboROF()">
                      </kendo-datepicker>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="borderedSections" [class.active-step-shedule-report]="currentStep === 4">
            <div class="row">
              <div class="col-12">
                <div class="rtClass">
                  Who do you want to send the "Schedule Report" to?
                </div>
              </div>
              <div class="col-12 margin-top-10">
                @if (_persons) {
                  <asap-fields-select-from-boxes (selectedFieldsOutput)="_onpersonChange($event)"
                    [fields]="_persons" [selectedFields]="_selectedPersons" [displayFieldName]="'code'"
                    [title]="'Person'" [fullWidth]="true" [showFilters]="true">
                  </asap-fields-select-from-boxes>
                }
              </div>
            </div>
          </div>
          <div class="borderedSections" [class.active-step-shedule-report]="currentStep === 5">
            <div class="row">
              <div class="col-12">
                <div class="rtClass">
                  What kind of format do you want the "Schedule Report" to be?
                </div>
              </div>
              <div class="col-12 margin-top-10">
                <div class="row">
                  <div class="col-5 col-sm-4 col-md-3">
                    <label for="emailReportTo" class="control-label reportslabelFix">
                      Choose Report
                      Format
                    </label>
                  </div>
                  <div class="col-12 col-sm-8 col-md-9">
                    <kendo-combobox #kendo_Combo_Report_Format [data]="_listOfReportFormats"
                      class="bordered hideClearButton scheduleReportMinWidth" [suggest]="true"
                      [textField]="'code'" [clearButton]="true" [valueField]="'id'"
                      placeholder="Choose a format" formControlName="reportformat" (open)="_reportFormatOpen()" required>
                    </kendo-combobox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (currentStep >= 4 && (_selectedPersons.length !== 0 && _form.get('reportformat').value != null)) {
        <div class="row"
          >
          <div class="col-12" style="margin-top:10px">
            <button kendoButton class="steps_buttons_class" (click)="_onCancel()">
              <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
              <span>close</span>
            </button>
            <button kendoButton class="steps_buttons_class" (click)="_onDelete()">
              <img class="backimage" [src]="'/assets/menu/'+ _theme +'/delete-schedule-report-icon-green.svg'" />
              <span>Delete</span>
            </button>
            <button kendoButton class="steps_buttons_class" (click)="_onSave($event)">
              <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
              <span>save</span>
            </button>
          </div>
        </div>
      }
    </form>
  </kendo-window>
}
